var map = {
	"./Ahorro-N.png": "4404",
	"./Ahorro-R.png": "62e3",
	"./Benef 1.png": "8d12",
	"./Benef 2.png": "105c",
	"./Benef 3.png": "5cc4",
	"./Benef 4.png": "015f",
	"./Benef 5.png": "1cf9",
	"./Benef 6.png": "0d42",
	"./Benef 7.png": "91d7",
	"./Calidad-N.png": "eac2",
	"./Calidad-R.png": "9b40",
	"./Limpieza-N.png": "d5d8",
	"./Limpieza-R.png": "e2c4",
	"./Logistica-N.png": "1751",
	"./Logistica-R.png": "d54a",
	"./Rendimiento-N.png": "788a",
	"./Rendimiento-R.png": "e97a",
	"./Tiempo-N.png": "4c58",
	"./Tiempo-R.png": "b9e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";